import { NewSiteFormProvider } from '@/pages/sites/new-site/context'
import NewSite from '@/pages/sites/new-site'
import { createFileRoute } from '@tanstack/react-router'
import z from 'zod'

const searchSchema = z.object({
  duplicateFrom: z.string().optional(),
})

export const Route = createFileRoute('/_authenticated/org/$orgId/sites/new')({
  component: NewSitePage,
  validateSearch: searchSchema,
})

function NewSitePage() {
  const { duplicateFrom } = Route.useSearch()

  return (
    <NewSiteFormProvider duplicateFromId={duplicateFrom}>
      <NewSite />
    </NewSiteFormProvider>
  )
}
